export default {
  data() {
    return {
      btnList: ['Acquisition / Ingestion', 'Production', 'Master Control', 'Distribution / Monetization'],
      popupInfo: {
        visiable: false,
        title: ''
      },
      program: ''
    };
  },
  methods: {
    jumpPage(program) {
      this.program = program;
      switch (program) {
        case 'Acquisition / Ingestion':
          window.open(`${location.href}preview?program=MediaHub`, '_blank');
          break;
        case 'Production':
          this.$set(this.popupInfo, 'visiable', true);
          this.$set(this.popupInfo, 'title', 'Open Monitor for Producer');
          break;
        case 'Master Control':
          this.$set(this.popupInfo, 'visiable', true);
          this.$set(this.popupInfo, 'title', 'Open Monitor for Master Control');
          break;
        case 'Distribution / Monetization':
          window.open(`${location.href}preview?program=NocGrid`, '_blank');
          break;
      }
    }
  }
};